import { Icon } from '@iconify/react'
import { formatRelative } from '../utils/events'

const Header = ({ status, fetchedAt, onReload, onToggleSidebar, sidebarOpen }) => {
    const loading = status === 'loading'

    return (
        <header className="header">
            <button
                type="button"
                className="header__toggle"
                onClick={onToggleSidebar}
                aria-expanded={sidebarOpen}
                aria-label={sidebarOpen ? 'Masquer le panneau' : 'Afficher le panneau'}
            >
                <Icon icon={sidebarOpen ? 'mdi:backburger' : 'mdi:menu'} aria-hidden="true" />
            </button>

            <div className="header__brand">
                <Icon icon="mdi:fire" className="header__logo" aria-hidden="true" />
                <div>
                    <h1 className="header__title">Suivi des feux de forêts</h1>
                    <p className="header__subtitle">NASA EONET v3 · couverture mondiale</p>
                </div>
            </div>

            <div className="header__status">
                <span className={`status-dot status-dot--${status}`} aria-hidden="true" />
                <span className="header__status-text">
                    {status === 'error'
                        ? 'Données indisponibles'
                        : loading
                            ? 'Actualisation…'
                            : `Mis à jour ${formatRelative(fetchedAt)}`}
                </span>
            </div>

            <button type="button" className="btn btn--ghost" onClick={onReload} disabled={loading}>
                <Icon icon="mdi:refresh" className={loading ? 'spin' : undefined} aria-hidden="true" />
                <span className="btn__label">Actualiser</span>
            </button>
        </header>
    )
}

export default Header
